<template>
  <div class="schedule schedule--summary background-gray min-height-inherit">
    <section class="py-4 py-md-5">
      <div class="container container--md">
        <div class="summary box">
          <h1 class="title title--l text-primary weight-bolder text-center">
            Revisa los datos de tu reserva servicio agendamiento
          </h1>

          <div class="summary__list">
            <div
              v-if="current_brand && current_user"
              class="summary__item summary__item--highlight"
            >
              <h3 class="title text-primary weight-bolder">
                {{ current_brand.name }}
              </h3>
              <p class="mb-0">{{ current_user.car.model.name }}</p>
              <!-- <p class="text mb-0">
                {{ current_user.car.year }}
              </p>-->
            </div>
            <div v-if="current_schedule.service" class="summary__item">
              <p class="summary__label text weight-bold">
                Servicio seleccionado:
              </p>
              <h3 class="title text-primary weight-bolder">
                {{ current_schedule.service.name }}
              </h3>
              <router-link
                class="summary__edit button"
                :to="{ name: 'schedule-service' }"
              >
                <i class="button__icon material-icons">edit</i>
              </router-link>
            </div>
            <div v-if="current_schedule.office" class="summary__item">
              <p class="summary__label text weight-bold">
                Sucursal seleccionada:
              </p>
              <h3 class="title text-primary weight-bolder">
                {{ current_schedule.office.office.name }}
              </h3>
              <p class="text my-1 mb-0">
                {{ current_schedule.office.office.address }}
              </p>
              <router-link
                class="summary__edit button"
                :to="{ name: 'schedule-place' }"
              >
                <i class="button__icon material-icons">edit</i>
              </router-link>
            </div>
            <div v-if="current_schedule.specialist" class="summary__item">
              <p class="summary__label text weight-bold">Asesor de servicio:</p>
              <h3 class="title text-primary weight-bolder">
                {{ current_schedule.specialist.name }}
                {{ current_schedule.specialist.lastname }}
              </h3>
              <router-link
                class="summary__edit button"
                :to="{
                  name: 'schedule-specialist',
                  params: { service: current_schedule.service_slug },
                }"
              >
                <i class="button__icon material-icons">edit</i>
              </router-link>
            </div>
            <div v-if="current_schedule.date" class="summary__item">
              <p class="summary__label text weight-bold">
                Fecha y hora seleccionada:
              </p>
              <h3 class="title text-primary weight-bolder">
                <span class="text-capitalize">{{
                  dateFormat(current_schedule.date.day)
                }}</span>
                -
                {{ formattedTime(current_schedule.date.hour.appointment_time) }}
                hrs
              </h3>
              <router-link
                v-if="!current_schedule.specialist"
                class="summary__edit button"
                :to="{ name: 'schedule-date' }"
              >
                <i class="button__icon material-icons">edit</i>
              </router-link>
            </div>
            <div class="summary__item">
              <ValidationProvider
                class="form-group"
                name="comentarios"
                vid="comments"
                rules="max:250"
                v-slot="{ classes, errors }"
                tag="div"
                key="comments"
                persist
              >
                <label
                  class="summary__label text weight-bold mb-2"
                  for="comments"
                >
                  Comentarios adicionales
                </label>
                <textarea
                  :class="['form-control', classes]"
                  id="comments"
                  v-model="comments"
                  rows="4"
                  placeholder="Ingresa cualquier comentario que debamos considerar..."
                ></textarea>
                <span
                  v-if="errors.length"
                  class="form-helper form-helper--error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
          </div>

          <div class="text-center mt-4">
            <button
              class="button button--secondary"
              :class="{ 'button--loading': loading }"
              :disabled="loading"
              @click="handleConfirmation"
            >
              <span
                class="button__text"
                v-text="loading ? 'Confirmando...' : 'Confirmar hora'"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { sendSchedule } from '@/services/schedule';

import moment from 'moment';

import { mapState } from 'vuex';

export default {
  name: 'ScheduleSummary',
  data() {
    return {
      loading: false,
      comments: '',
    };
  },
  mounted() {
    this.$store.dispatch('setCurrentStep', 0);

    this.executeDataLayer();

    this.$store.commit(
      'set_title',
      'Confirma la información para agendar la reserva de tu hora.',
    );
  },
  computed: {
    ...mapState(['current_brand', 'current_user', 'current_schedule']),
  },
  methods: {
    executeDataLayer: async function() {
      if (!window.dataLayer) {
        return;
      }

      const eventData = {
        event: 'agendamiento-paso',
        paso: 4,
      };

      console.log('Sent to dataLayer', eventData);

      window.dataLayer.push(eventData);
    },
    handleConfirmation() {
      this.loading = true;

      const data = {
        appointment_id: this.current_schedule.date.hour.id,
        contact_first_name: this.current_user.user.firstname,
        contact_last_name: this.current_user.user.lastname,
        contact_email: this.current_user.user.email,
        kms: this.current_user.car.mileage,
        contact_phone: this.current_user.user.phone,
        contact_rut: this.current_user.user.rut,
        license_plate: this.current_user.car.license,
        vehicle_model_id: this.current_user.car.model.id,
        comments: this.comments,
      };

      if (this.current_schedule.old_appointment_id) {
        data.old_appointment_id = this.current_schedule.old_appointment_id;
      }

      this.sendScheduleToApi(data)
        .then(order => {
          this.$store
            .dispatch('setOrder', order)
            .then(() => this.$router.push({ name: 'schedule-confirmation' }));
        })
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido confirmar tu servicio',
          });
        })
        .then(() => (this.loading = false));
    },
    formattedTime(time) {
      return time.substring(0, time.length - 3);
    },
    dateFormat(date) {
      return moment(date)
        .locale('es')
        .format('dddd DD MMMM');
    },
    async sendScheduleToApi(data) {
      const response = await sendSchedule(data);
      return response.data.data;
    },
  },
};
</script>
